export interface ICheckListFieldItem {
  text: string;
  unit: string;
}

export enum CheckListType {
  Single = "single",
  Group = "group",
  GroupItem = "group item",
}

export interface ICheckListForm {
  name: string;
  desc: string;
  lbid: string | string[];
  type: CheckListType;
  sort: number;
  list: any[];
}

export interface ICheckListItem {
  active: number;
  archived: number;
  cid: string;
  clientid: string;
  data: {
    type: CheckListType;
    list: any[];
  };
  sort: number;
  description: string;
  lbid: string | string[];
  name: string;
  version: string;
  updateddate: string;
  yachtid: string;
}
